import produce from 'immer';
export const FEEDBACK_FORM_ACTION_TYPES = {
  SET_CHECKBOX_FEEDBACK: 'SET_CHECKBOX_FEEDBACK',
  SET_OTHER_FEEDBACK: 'SET_OTHER_FEEDBACK',
  SET_CONTACT_ME: 'SET_CONTACT_ME'
};
export const initialState = {
  checkboxInputFeedback: {},
  contactMe: false,
  otherFeedback: ''
};
export const feedbackFormStateReducer = produce((draft, action) => {
  switch (action.type) {
    case FEEDBACK_FORM_ACTION_TYPES.SET_CONTACT_ME:
      draft.contactMe = action.payload;
      break;
    case FEEDBACK_FORM_ACTION_TYPES.SET_CHECKBOX_FEEDBACK:
      {
        const formVal = action.payload;
        if (formVal in draft.checkboxInputFeedback) {
          delete draft.checkboxInputFeedback[formVal];
        } else {
          draft.checkboxInputFeedback[formVal] = true;
        }
        break;
      }
    case FEEDBACK_FORM_ACTION_TYPES.SET_OTHER_FEEDBACK:
      draft.otherFeedback = action.payload;
      break;
    default:
      break;
  }
});